import { IntlFormatters } from "react-intl";
import defineMessages from "../defineMessages";

const folksongClassMessages = defineMessages({
    old: {
        id: "meta.folksongClass.old",
    },
    new: {
        id: "meta.folksongClass.new",
    },
    mixed: {
        id: "meta.folksongClass.mixed",
    },
});

export const folksongClasses = (fm: IntlFormatters["formatMessage"]) => [
    { value: "old", label: fm(folksongClassMessages["old"]) },
    { value: "new", label: fm(folksongClassMessages["new"]) },
    { value: "mixed", label: fm(folksongClassMessages["mixed"]) },
];
